import * as React from 'react';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../_pageWrappers/MemberPageWrapper';
import { AgendaMeetingListingView } from '../_components/activities/AgendaMeetingListingView';

export default function AnnualWorkgroupStatusListingPage(): JSX.Element 
{
	return (
		<MemberPageWrapper selectedMenuItemKey="annualworkgroupstatus" breadCrumbs={[{ text: 'Årlige drøftelser', url: '' }]}>
            <AnnualWorkgroupStatusListingPageContent />
		</MemberPageWrapper>
	);
}

function AnnualWorkgroupStatusListingPageContent(): JSX.Element
{
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewActivity']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <AgendaMeetingListingView
            generalActivityHeaderText='Årlige drøftelser'
            generalActivityHeaderIcon='forum'
            currentActivitiesHeaderIcon='forum'
            createNewButtonText='Opret ny årlig drøftelse'
            currentActivitiesHeaderText='Aktuelle årlige drøftelser'
            pastActivitiesHeaderText='Tidligere årlige drøftelser'
            pastActivitiesHeaderIcon='chat_mark'
            type='AnnualWorkgroupStatus' />
    );
}
